export default __webpack_public_path__ + "aa0c734.png";